<template>
  <div class="reports">
    <div v-if="$store.state.pageLoaded" class="reports-listing">
      <div v-if="$store.state.receivedData.performancesSimple.list.length > 0">
      <md-table v-model="$store.state.receivedData.performancesSimple.list" md-sort="id">
        <md-table-row md-selectable="single" slot="md-table-row" slot-scope="{ item }" md-auto-select>
          <md-table-cell md-label="Predstava" md-sort-by="play_title">{{ item.play_title }}</md-table-cell>
          <md-table-cell md-label="Datum" md-sort-by="performance_date">{{ item.performance_date }}</md-table-cell>
          <md-table-cell md-label="Vrijeme" md-sort-by="performance_time">{{ item.performance_time }}</md-table-cell>
          <md-table-cell md-label="Kupac" class="actions-cell t-align-center">
            <md-button class="md-dense md-primary md-raised" v-on:click="showReport(item)">Vidi izvješće</md-button>
            </md-table-cell>
        </md-table-row>
      </md-table>
       <md-dialog :md-active.sync="reportVisible" class="md-scrollbar dialog-container report-dialog">
          <md-dialog-title>Način plaćanja</md-dialog-title>
          <md-button class="md-icon-button md-raised md-accent back-button" title="Natrag" v-on:click="reportVisible = false">
            <md-icon>keyboard_arrow_left</md-icon>
          </md-button>
          <div ref="reports" class="print-wrapper">
            <h2 class="md-title">
              Gratis ulanice: {{ selectedPerformance.play_title }}, {{ selectedPerformance.performance_date }}, {{ selectedPerformance.performance_time }}
            </h2>
            <md-table v-if="reportVisible && $store.state.selectedObject.hasOwnProperty('rows')" class="print-table small-table">
              <md-table-row>
                <md-table-head>Kupac</md-table-head>
                <md-table-head>Kategorija</md-table-head>
                <md-table-head>Količina</md-table-head>
                <md-table-head class="t-align-right">Cijena</md-table-head>
                <md-table-head class="t-align-right">Iznos</md-table-head>
              </md-table-row>
              <md-table-row v-for="value, key in $store.state.selectedObject.rows">
                <md-table-cell>{{ value.buyer }}</md-table-cell>
                <md-table-cell>{{ value.category }}</md-table-cell>
                <md-table-cell>{{ value.count }}</md-table-cell>
                <md-table-cell class="t-align-right">{{ formatCurrency(value.price) }}</md-table-cell>
                <md-table-cell class="t-align-right">{{ formatCurrency(value.amount) }}</md-table-cell>
              </md-table-row>
              <md-table-row class="last-row">
                <md-table-cell></md-table-cell>
                <md-table-cell><strong>Ukupno</strong></md-table-cell>
                <md-table-cell>{{ $store.state.selectedObject.count }}</md-table-cell>
                <md-table-cell></md-table-cell>
                <md-table-cell class="t-align-right">{{ formatCurrency($store.state.selectedObject.amount) }}</md-table-cell>
              </md-table-row>
            </md-table>
             <md-button class="md-primary md-dense md-raised print-btn" v-on:click="print($refs.reports)">
              Ispiši
            </md-button>
          </div>
        </md-dialog>
      </div>
      <div v-else class="error">
        <h3>Nažalost nema izvješća za prikaz</h3>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsMixin from '../../../mixins/reports-mixin';
import FormatCurrency from '../../../mixins/format-currency';

export default {
  name: 'ReportsPlay',
  mixins: [FormatCurrency, ReportsMixin('getReportsPlay')],
  data(){
    return{
      reportVisible: false,
      selectedPerformance: {},
    }
  },

  methods:{
    showReport(performance){
      this.selectedPerformance = JSON.parse(JSON.stringify(performance));
      this.$store.dispatch('getReportsGratisByDate', performance.id);
      this.reportVisible = true;
    }
  }
}
</script>

<style lang="scss" scoped>
  .report-dialog{
    .md-dialog-container{
    }
    .print-wrapper{
      position: relative;
      padding: 35px 35px 100px;
    }
    .print-btn{
      position: absolute;
      right: 35px;
      bottom: 35px;
    }
    .md-title{
      span{
        display: block;
      }
    }

    .description{
      margin: 20px 0;
      td{
        padding: 6px 32px 6px 24px;
        font-size: 13px;
      }
    }
  }

  .filter-wrapper{
    display: flex;
    position: relative;
    max-width: 900px;

    .md-field{
      margin-right: 20px;
    }
  }

  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

  .single-table{
    margin-top: 75px;
    &:last-of-type{
      margin-bottom: 50px;
    }

    h3{
      margin-left: 20px;
    }
  }

  .reports-table{
    max-width: 900px;
		.md-table-cell, .md-table-head{
			&:not(:first-of-type){
				text-align: right;
			}
    }

    .md-table-cell{
      text-transform: capitalize;
    }

    .md-table-row:last-of-type{
      font-weight: bold;
    }
	}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsGratisByDate.vue